export default {
  size: 64
};



// WEBPACK FOOTER //
// ./src/settings/board.js